import { NgModule } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';

import { AlertComponent } from './alert.component';
import { CheckboxComponent } from './checkbox.component';
import { ConfirmComponent } from './confirm.component';
import { DlgAlertComponent } from './dlg-alert.component';
import { DlgConfirmComponent } from './dlg-confirm.component';
import { HorizontalScrollComponent } from '../ui.module/horizontal-scroll.component';
import { InputNumberComponent } from './input-number.component';
import { RadioColorComponent } from '../ui.module/radio-color.component';
import { RarityComponent } from './rarity.component';
import { RoomComponent } from '../ui.module/room.component';
import { SectionHeaderComponent } from '../ui.module/section-header.component';
import { SelectListComponent } from '../ui.module/select-list.component';
import { SelectComponent } from '../ui.module/select.component';
import { TargetRoomComponent } from '../ui.module/target-room.component';

import { AlertService } from './alert.service';
import { ConfirmService } from './confirm.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatSelectModule
    ],
    declarations: [
        AlertComponent,
        CheckboxComponent,
        ConfirmComponent,
        DlgAlertComponent,
        DlgConfirmComponent,
        HorizontalScrollComponent,
        InputNumberComponent,
        RadioColorComponent,
        RarityComponent,
        RoomComponent,
        SectionHeaderComponent,
        SelectListComponent,
        SelectComponent,
        TargetRoomComponent
    ],
    exports: [
        AlertComponent,
        CheckboxComponent,
        ConfirmComponent,
        DlgAlertComponent,
        DlgConfirmComponent,
        HorizontalScrollComponent,
        InputNumberComponent,
        RadioColorComponent,
        RarityComponent,
        RoomComponent,
        SectionHeaderComponent,
        SelectListComponent,
        SelectComponent,
        TargetRoomComponent
    ],
    entryComponents: [
        DlgAlertComponent,
        DlgConfirmComponent
    ],
    providers: [
        AlertService,
        ConfirmService
    ]
})
export class UIModule {
}

declare const angular: angular.IAngularStatic;

angular.module('app')
    .factory('AlertService', downgradeInjectable(AlertService) as any);

angular.module('app')
    .factory('ConfirmService', downgradeInjectable(ConfirmService) as any);
